import React from 'react'

export default function docFolder(props) {
  const { className } = props

  return (
    <div className={className ? className : ''}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 32 36"
      >
        <g >
          <path
            fill="#2B579A"
            d="M30.03 9.53v21.7c0 1.68-1.4 2.99-2.99 2.99H6.36c-1.68 0-2.99-1.4-2.99-2.99V5.04c0-1.68 1.31-3.09 2.99-3.09h16.09c.47 0 1.03.19 1.31.56l5.71 5.61c.28.37.56.84.56 1.4v.01Z"
            className="st1"
            opacity=".1"
          />
          <g >
            <path
              fill="#2B579A"
              d="M7.85 17.75h18.47c.62 0 1.13.37 1.13.83 0 .45-.51.83-1.13.83H7.85c-.62 0-1.13-.37-1.13-.83 0-.45.51-.83 1.13-.83Zm18.92 4.22H7.4a.68.68 0 0 0-.68.68v.29c0 .376.305.68.68.68h19.37a.68.68 0 0 0 .68-.68v-.29a.68.68 0 0 0-.68-.68Zm0 4.22H7.4a.68.68 0 0 0-.68.68v.29c0 .376.305.68.68.68h19.37a.68.68 0 0 0 .68-.68v-.29a.68.68 0 0 0-.68-.68Z"
              className="st1"
            />
          </g>
          <path
            fill="#2B579A"
            d="m30.4 7.61-5.99-5.8c-.28-.37-.84-.56-1.31-.56H6.27a3.15 3.15 0 0 0-3.18 3.18v27.32c0 1.78 1.4 3.18 3.18 3.18h21.61c1.78 0 3.18-1.4 3.18-3.09V9.2c.09-.65-.19-1.22-.65-1.59h-.01Zm-.46 23.3c0 1.59-1.31 2.99-2.9 2.99H7.11c-1.59 0-2.9-1.31-2.9-2.99V5.28c0-1.59 1.31-2.99 2.9-2.99h15.44c.47 0 .94.19 1.31.56l5.52 5.43c.37.37.65.94.56 1.5v21.14-.01Z"
            className="st1"
          />
          <path
            fill="#3986C7"
            d="M1.32 4.99h15.66c.51 0 .92.42.92.96v6.01c0 .53-.41.96-.92.96H.4V5.96c0-.53.41-.94.92-.94v-.03Z"
            className="st2"
          />
          <path
            fill="#436FB6"
            d="M17.83 11.82v.12c0 .53-.41.96-.92.96H.34V5.94c0-.53.41-.96.92-.96h.48v2.47c0 2.41 1.87 4.37 4.2 4.37h11.9-.01Z"
            className="st3"
          />
          <path
            fill="#436FB6"
            fill-opacity=".6"
            d="m.34 12.89 2.78 3.28v-3.28H.34Z"
            className="st3"
            opacity=".3"
          />
          <g class="Group">
            <g class="Group">
              <path
                fill="#F1F2F2"
                d="M4.953 11H3.332V6.615H4.95c.447 0 .831.087 1.154.263a1.8 1.8 0 0 1 .75.754c.175.327.263.718.263 1.173 0 .457-.088.85-.264 1.178a1.8 1.8 0 0 1-.747.756c-.324.174-.709.261-1.154.261Zm-.561-.904h.52c.246 0 .453-.041.623-.124a.82.82 0 0 0 .388-.409c.088-.19.133-.442.133-.758 0-.315-.045-.567-.133-.754a.819.819 0 0 0-.392-.406 1.429 1.429 0 0 0-.634-.127h-.505v2.578Zm7.484-1.289c0 .483-.093.892-.278 1.227-.186.336-.437.59-.754.765a2.16 2.16 0 0 1-1.062.261 2.15 2.15 0 0 1-1.065-.263 1.918 1.918 0 0 1-.751-.765c-.184-.335-.276-.744-.276-1.225 0-.482.092-.891.276-1.227a1.9 1.9 0 0 1 .751-.764c.316-.174.67-.261 1.065-.261.392 0 .746.087 1.062.26.317.175.568.43.754.765.185.336.278.745.278 1.227Zm-1.084 0a1.9 1.9 0 0 0-.122-.723.95.95 0 0 0-.347-.448.944.944 0 0 0-.541-.152.95.95 0 0 0-.542.152.962.962 0 0 0-.35.448c-.08.197-.12.438-.12.723 0 .286.04.527.12.724a.962.962 0 0 0 .35.448.95.95 0 0 0 .542.152c.21 0 .392-.051.541-.152a.95.95 0 0 0 .347-.448 1.9 1.9 0 0 0 .122-.724Zm5.683-.604h-1.07a.93.93 0 0 0-.088-.297.725.725 0 0 0-.435-.37.992.992 0 0 0-.327-.052.96.96 0 0 0-.55.156.997.997 0 0 0-.354.452 1.872 1.872 0 0 0-.122.715c0 .291.041.536.124.733a.975.975 0 0 0 .354.443.977.977 0 0 0 .541.148c.117 0 .224-.015.32-.045a.722.722 0 0 0 .437-.343.867.867 0 0 0 .1-.285l1.07.007a1.62 1.62 0 0 1-.169.574c-.093.188-.22.36-.383.516a1.812 1.812 0 0 1-.595.368 2.18 2.18 0 0 1-.801.137c-.397 0-.752-.087-1.067-.261a1.881 1.881 0 0 1-.74-.767c-.182-.335-.272-.744-.272-1.225 0-.482.092-.891.276-1.227a1.89 1.89 0 0 1 .747-.764 2.14 2.14 0 0 1 1.056-.261c.265 0 .51.037.736.11.226.074.424.18.596.322.171.14.31.312.417.516.107.204.174.438.2.7Z"
                className="doc"
              />
            </g>
          </g>
        </g>
      </svg>
    </div>
  )
}
